export default __webpack_public_path__ + "static/media/Eb4.fca02eca.mp3";